import React, { useState } from 'react';
import './loginForm.css'

function LoginForm({Login, error}) {
    const [details, setDetails] = useState({name: '', password: ''})
    
    const submitHandler = e =>{
        e.preventDefault()
        Login(details)
    }

    return (
        <div className="mainContainer" onSubmit={submitHandler}>
            <form className="loginForm" autoComplete='off'>
                <h2>LOGIN</h2>
                {(error != '') ? (<div style={{textAlign: 'center', color: 'red'}}>{error}</div>) : ''}

                <div className="wrapper">
                    <input type="text" autoComplete='off' className='name' name='name' id='name' placeholder='USERNAME'  onChange={e => setDetails({...details, name: e.target.value})} value={details.name}/>
                    <input type="password" autoComplete='off' className='password' name='password' id='password' placeholder='PASSWORD' onChange={e => setDetails({...details, password: e.target.value})} value={details.password}/>
                    <input type="submit" className="button" value='LOG IN'/>
                </div>        
            </form>
        </div>
    )
}
export default LoginForm;
